import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { ssoLogin } from '../../data/login/login.actions';
import { retrieveToken } from '../../services/auth.service';

class SsoPage extends React.Component {
  static propTypes = {
    errors: PropTypes.array,
    ssoLogin: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    loggedIn: PropTypes.bool.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  }

  static defaultProps = {
    errors: []
  };

  componentDidMount() {
    const parsed = queryString.parse(this.props.location.search);
    const ssoToken = parsed.ssotoken;
    this.props.ssoLogin(ssoToken);
  }

  componentDidUpdate(prevProps) {
    if (this.props.loading !== prevProps.loading && this.props.loggedIn) {
      const token = retrieveToken();
      if (token != null) {
        this.props.history.push('/');
      }
    }
  }

  render() {
    const { errors } = this.props;
    if (errors && errors.length) {
      return (
        <div>SSO Errors <br />{errors}</div>
      );
    }

    return (
      <div>Attempting SSO login...</div>
    );
  }
}

function mapStateToProps(state) {
  return { errors: state.errors, ...state.login };
}

const actions = { ssoLogin };

export default connect(mapStateToProps, actions)(SsoPage);
